import { get } from 'lodash';
import { TEAM_PAGE } from './actionTypes';
import { CommonMapper } from 'mappers/common';
import { TeamMapper } from 'mappers/team';

const getTeamData = (vertical_id, url_slug) => (
  dispatch,
  getState,
  { api }
) => {
  dispatch({
    type: TEAM_PAGE.TEAM_PAGE_REQUEST,
    payload: {},
    test: api
      .post(`teams.json`, {
        vertical_id: vertical_id,
        restaurant_slug: url_slug,
      })
      .then(res => {
        const response = get(res, 'data.data', {});
        const mediaPath = CommonMapper.extractMediaPath(response);
        dispatch({
          type: TEAM_PAGE.TEAM_PAGE_SUCCESS,
          payload: TeamMapper.formatTeamData(response, mediaPath, vertical_id),
        });
        return res.data;
      })
      .catch(error => {
        dispatch({
          type: TEAM_PAGE.TEAM_PAGE_FAILURE,
          error,
        });
      }),
  });
};

export const TeamActions = {
  getTeamData,
};
